import { getLookupList } from "../utils/apiUtils"
import { ENTITY_NAME_BACK_OFFICE_FIRM_STATUS } from "./dbConstants"
import { getLanguageOptions } from "@/shared/constants/languages"

export const getStatusListOptions = async() => {
  return getLookupList(ENTITY_NAME_BACK_OFFICE_FIRM_STATUS);
}

export const getLanguageListOptions = async() => {
  return getLanguageOptions();
}
